/**
 * Paired-devices card — the TV + remotes registered against the room. The TV row
 * is pinned to the top so "is the TV there?" is answered instantly.
 */

import type { Device } from '@spaces/contracts';
import { fmtRelative } from '../../ui/format';
import { Card, CardTitle, DeviceRoleTag, Mono } from '../../ui/primitives';
import { TableEl, TdSm, ThSm } from '../../ui/table';

function sortTvFirst(devices: Device[]): Device[] {
    return [...devices].sort((a, b) => Number(b.role === 'spot-tv') - Number(a.role === 'spot-tv'));
}

export function DevicesCard({ devices }: { devices: Device[] }): JSX.Element {
    return (
        <Card>
            <CardTitle>Paired devices ({devices.length})</CardTitle>
            {devices.length === 0 ? (
                <div style={{ fontSize: 13, color: 'inherit', opacity: 0.7 }}>No devices paired yet.</div>
            ) : (
                <TableEl>
                    <thead>
                        <tr>
                            <ThSm>Role</ThSm>
                            <ThSm>Label</ThSm>
                            <ThSm>Device id</ThSm>
                            <ThSm>Last seen</ThSm>
                        </tr>
                    </thead>
                    <tbody>
                        {sortTvFirst(devices).map(d => (
                            <tr key={d.id}>
                                <TdSm><DeviceRoleTag role={d.role} /></TdSm>
                                <TdSm>{d.label ?? '—'}</TdSm>
                                <TdSm><Mono style={{ fontSize: 12 }}>{d.id}</Mono></TdSm>
                                <TdSm style={{ opacity: 0.75 }}>{fmtRelative(d.lastSeenAt)}</TdSm>
                            </tr>
                        ))}
                    </tbody>
                </TableEl>
            )}
        </Card>
    );
}
